import React, { useEffect, useState } from 'react'
import { MultiSelect as MultiSelectPR } from 'primereact/multiselect'
import './../form.scss'
import { PropsType } from '../../../models/util'
import CheckboxInput from '../CheckboxInput'

interface MultiSelectProps extends PropsType {
    onChangeCallback: (e: any) => void // on change callback
    value: any[] // input values

    // to override primereact and/or wardrobe styles, use custom classes
    classes?: string // css classes for the element
    containerClasses?: string // css classes for the <div> container
    style?: any

    optionsList?: any[] // options list for select and multiselect
    filterable?: boolean // adds searchbar for select and multiselect dropdowns

    mandatory?: boolean // adds * in labels (TODO validation message)
    clearable?: boolean // add 'x' icon to clear the field
    disabled?: boolean // if true the element is disabled
    colWidth?: number | string // set element width from 1 to 12 columns (default: 12)

    label?: string // label
    label2?: string // custom label for "select all" checkbox
    floatingLabel?: boolean // floating labels appear only when the field is filled in
    placeholder?: string // placeholder

    onRemoveChip?: (e: any) => void // TODO fix
    additionalProps?: any // pass props for the Prime React original component
    // includes:
    // maxSelectedLabels?: number // limit beyond which to show the number of selected items

    fixedPlaceholder?: boolean // Whether to display selected items in the label section or always display the placeholder as the default label.

    // the dropdown icon is not customizable

    showSelectedCount?: boolean // if true, the input shows the count of selected items instead of chips
    maxSelectedLabels?: number // number that defines how many labels are shown inside the multiselect
    selectedCountLabel?: string // if specified, print a custom label when showSelectedCount is true
}

const MultiSelect = (props: MultiSelectProps) => {
    const {
        onChangeCallback,
        optionsList,
        value,
        placeholder,
        classes,
        style,
        colWidth,
        disabled,
        additionalProps,
        containerClasses,
        filterable,
        clearable,
        floatingLabel,
        label,
        label2,
        mandatory,
        showSelectedCount,
        maxSelectedLabels,
        fixedPlaceholder,
        selectedCountLabel,
    } = props

    const [checked, setChecked] = useState(false)

    useEffect(() => {
        if (value?.length === optionsList?.length) {
            setChecked(true)
        } else {
            setChecked(false)
        }
    }, [value, optionsList])

    const getSelectedItemTemplate = (
        value: any,
        optionLabel?: string,
        optionValue?: string,
        valuePropName?: string
    ) => {
        // console.log('SELECTED ITEM TEMPALTE', optionLabel, optionValue)
        if (value && optionLabel && (optionValue || valuePropName)) {
            // console.log('MULTISELECT SELECTED ITEM TEMPLATE', value)
            let find = optionsList.find((item: any) => {
                if (valuePropName) {
                    return item[valuePropName] === value[valuePropName]
                }
                return item[optionValue] === value
            })

            if (find) {
                return find[optionLabel]
            }
        } else if (value && optionLabel && value[optionLabel]) {
            return value[optionLabel]
        }
        return value?.toString()
    }

    const panelHeaderTemplate = (opt) => {
        const _selectAllLabel = label2 ? label2 : 'Select All'
        return (
            <div className="p-multiselect-header p-d-flex p-flex-wrap-reverse">
                <CheckboxInput
                    value={checked}
                    onChangeCallback={(val) => {
                        opt.onChange()
                        setChecked(val.target.checked)
                    }}
                    label={_selectAllLabel}
                />
                {filterable && opt.filterElement}
            </div>
        )
    }

    const getSelectedItemsLabel = (value: any) => {
        let num: string = '0'
        if (value) {
            num = value.length === optionsList.length ? 'All' : value.length
        }

        return num + ' items selected'
    }

    return (
        <div
            className={`wardrobe-form-input p-col-${
                colWidth ? colWidth : '12'
            } ${containerClasses ? containerClasses : ''} ${
                label ? 'labeled-input' : ''
            }`}>
            <MultiSelectPR
                maxSelectedLabels={
                    maxSelectedLabels !== undefined
                        ? maxSelectedLabels
                        : optionsList?.length
                }
                {...additionalProps}
                // dropdownIcon={icon}
                placeholder={placeholder}
                fixedPlaceholder={fixedPlaceholder}
                panelClassName="wardrobe-form-panel"
                style={style}
                options={optionsList || []}
                disabled={disabled}
                className={`${classes} w-100`}
                onChange={(e) => {
                    //console.log('MULTISELECTE SELECTION', e)
                    onChangeCallback(e.target.value)
                    setChecked(e.target.value?.length === optionsList.length)
                }}
                value={value}
                display={fixedPlaceholder ? '' : 'chip'}
                filter={filterable}
                showClear={clearable}
                panelHeaderTemplate={panelHeaderTemplate}
                {...(showSelectedCount && {
                    selectedItemsLabel:
                        selectedCountLabel || getSelectedItemsLabel(value),
                    selectedItemTemplate: (item: string | number) => {
                        // console.log('selectedItemTemplate', item)
                        const itemTemplate = getSelectedItemTemplate(
                            item,
                            additionalProps?.optionLabel,
                            additionalProps?.optionValue,
                            additionalProps?.valuePropName
                        )
                        return item ? (
                            <div className="p-multiselect-token">
                                <span className="p-multiselect-token-label">
                                    {itemTemplate}
                                </span>
                                <span
                                    className="p-multiselect-token-icon pi pi-times-circle"
                                    onClick={() => {
                                        // console.log(item, value)
                                        const newVal = value.filter(
                                            (v) =>
                                                getSelectedItemTemplate(
                                                    v,
                                                    additionalProps?.optionLabel,
                                                    additionalProps?.optionValue,
                                                    additionalProps?.valuePropName
                                                ) != itemTemplate
                                        )
                                        onChangeCallback(newVal)
                                    }}></span>
                            </div>
                        ) : (
                            <div style={{ height: '30px' }}>{placeholder}</div>
                        )
                    },
                })}
            />
            {label && (
                <label className={`${floatingLabel && !value ? 'empty' : ''}`}>
                    {`${label}${mandatory ? ' *' : ''}`}
                </label>
            )}
        </div>
    )
}

export default MultiSelect
